// extracted by mini-css-extract-plugin
module.exports = {"schedulesSection":"styles_schedulesSection__uj7uV","header":"styles_header__1Hrkz","newScheduleDescription":"styles_newScheduleDescription__21ybX"};